import { convertCentsToDollars, parsePriceInfo, getCachedCareSector } from "Utils/utils";
import createSelector from "../../Utils/reselect";
import { orderFormCategoriesCustomAfterOther } from "components/DynamicForms/shared/formCategoryUtils";

const spAdminStateData = (state) => {
  const { spAdmin } = state;
  return spAdmin || {};
};

export const getLoading = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("loading") || false
);

export const getError = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("error") || ""
);

export const getSpSettingLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spSettingLoader") || false
);

export const getSpSettingError = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spSettingError") || ""
);

export const getSpSetting = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spSetting") || null
);

export const getDashboard = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("sp_dashboard") || {}
);

export const getProgressBarDetails = createSelector(
  spAdminStateData,
  (spAdmin) => {
    const spDashbard = spAdmin.get("sp_dashboard" || {});
    if (spDashbard && Object.keys(spDashbard).length > 0) {
      return spDashbard.hasOwnProperty("on_boarding_progress")
        ? spDashbard.on_boarding_progress
        : [];
    }
    return [];
  }
);

export const getSpParticipantsListLoading = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spParticipantsListLoading") || false
);

export const getSpSettingUpdateLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spSettingUpdateLoader") || false
);

export const getParticipantsList = createSelector(
  spAdminStateData,
  (spAdmin) => {
    const data = spAdmin.get("sp_participants") || null;
    return data;
  }
);

export const getParticipantsListOptions = createSelector(
  spAdminStateData,
  (spAdmin) => {
    const data = spAdmin.get("sp_participants") || null;
    if (data) {
      return data?.participant?.data?.map((x) => ({
        ...x,
        value: x.id,
        label: `${x.first_name} ${x.last_name}`,
      }));
    }
    return [];
  }
);

export const getApplicants = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("sp_applicants") || []
);

export const getSPEmployeeDocuments = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("sp_employee_documents") || []
);

export const getSpWorkers = createSelector(spAdminStateData, (spAdmin) => {
  const data = spAdmin.get("sp_workers");
  if (!data) return [];
  return data.workers;
});

export const getSpWorkersAndManagers = createSelector(
  spAdminStateData,
  (spAdmin) => {
    const data = spAdmin.get("sp_workers");
    if (!data) return [];
    const managers =
      "manager_list" in data
        ? data.manager_list.map((x) => {
            const obj = { ...x, label: x.name, value: x.uuid };
            return obj;
          })
        : [];
    const workers = data.workers;
    return [...workers, ...managers];
  }
);

export const getSpSupportCoordinators = createSelector(
  spAdminStateData,
  (spAdmin) => {
    const data = spAdmin.get("sp_workers");
    if (!data) return [];
    return data.support_coordinators;
  }
);
export const getSpAlliedHealthWorkers = createSelector(
    spAdminStateData,
    (spAdmin) => {
        const data = spAdmin.get("sp_workers");
        if (!data) return [];
        return data.allied_health_workers;
    }
);

export const getSPFeedback = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("sp_feedback") || null
);

export const getSPComplaints = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("sp_complaints") || null
);

export const getSPQuestions = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("sp_questions") || null
);

export const getSPFormCategories = createSelector(
  spAdminStateData,
  (spAdmin) => {
    const categories = spAdmin.get("sp_form_categories") || [];
    return orderFormCategoriesCustomAfterOther(categories);
  }
);

export const SpFormCategoriesLaoder = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("form_category_loading") || false
);

export const spFormTemplates = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("sp_form_templates") || null
);

export const spFormTemplatesLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("form_templates_loading") || false
);

export const getDocuments = createSelector(spAdminStateData, (spAdmin) =>
  spAdmin.get("sp_documents" || null)
);

export const spDocUpdateLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spDocUpdateLoader") || false
);

export const getHrmDocuments = createSelector(spAdminStateData, (spAdmin) =>
  spAdmin.get("hrm_documents" || null)
);

export const getRiskRatingTabList = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("sp_riskRatingTabList") || null
);

export const getSubmittedFormsList = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("sp_submittedFormsList") || null
);

export const getSubmittedFormsListLoading = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("submittedFormsList_loading") || null
);

export const getSpManagersListLoading = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spManagersloading") || false
);

export const getManagers = createSelector(spAdminStateData, (spAdmin) => {
  const data = spAdmin.get("sp_managers") || [];

  return data?.map((x) => ({ ...x, value: x.manager_id, label: x.name }));
});

export const getRefreshManagerList = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("refreshManagerList") || false
);

export const getTeamManagmentListLoading = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("team_mamangement_list_loading") || false
);

export const getTeamManagmentListOptions = createSelector(
  spAdminStateData,
  (spAdmin) => {
    const data = spAdmin.get("hrm_team_managment") || null;
    if (data) {
      return data?.employees?.data?.map((x) => ({
        ...x,
        value: x.id,
        label: `${x.first_name} ${x.last_name}`,
      }));
    }
    return [];
  }
);

export const getTeamManagmentList = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("hrm_team_managment") || null
);

export const getWorkerLeaveList = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("workerLeaveList") || null
);

export const getWorkerHourlySettingLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("workerHourlySettingLoader") || false
);

export const getWorkerProfileDetailLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("workerProfileDataLoader") || false
);
export const getWorkerProfileError = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("workerProfileDataError") || null
);


export const getSelectedWorker = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("selectedWorker") || null
);

export const getWorkerStatusUpdateLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("workerStatusUpdateLoader") || false
);

export const getStripePricingTableLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("stripePricingTableLoader") || false
);

export const getStripePricingList = createSelector(
  spAdminStateData,
  (spAdmin) => {
    const PricingData = spAdmin.get("stripePricingTableList") || [];

    const transformData = (products) => {
      const transformedFeatures = {};
      products.forEach((product) => {
        const { name: plan, price_info } = product;

        const planKey = plan.toLowerCase().replace(/\s+/g, "_");

        const eligiblePrices = [...price_info].filter(
          (itemPrice) =>
            itemPrice?.active !== false || itemPrice?.is_current_subscription === true
        );

        eligiblePrices
          .sort((a, b) => {
            const aCurrent = a?.is_current_subscription === true ? 0 : 1;
            const bCurrent = b?.is_current_subscription === true ? 0 : 1;
            if (aCurrent !== bCurrent) {
              return bCurrent - aCurrent;
            }
            return (b?.created ?? 0) - (a?.created ?? 0);
          })
          .forEach((itemPrice) => {
            const {
              nickname,
              unit_amount,
              id: priceInfoId,
              recurring,
              metadata,
            } = itemPrice;
            const participantMax =
              metadata?.participant != null
                ? parseInt(metadata.participant, 10)
                : undefined;

            const parseNickName = parsePriceInfo(nickname, recurring);
            if (parseNickName === null) return;

            const { description, frequency, year } = parseNickName;
            const key = description.trim();
            const priceKey =
              recurring?.interval === "year" ? "yearly" : `${year}_year`;

            if (transformedFeatures[key]?.[planKey]?.[priceKey]) {
              return;
            }

            const stripeAmount = convertCentsToDollars(unit_amount);
            const displayAmount = Number.isInteger(stripeAmount)
              ? stripeAmount
              : stripeAmount.toFixed(2);

            const priceEntry = {
              monthly: `$${displayAmount} ${frequency}`,
              unit_amount: stripeAmount,
              price_id: priceInfoId,
              plan_type: recurring?.interval === "year" ? "yearly" : "monthly",
              ...(itemPrice?.is_current_subscription === true && {
                is_current_subscription: true,
              }),
              ...(participantMax !== undefined &&
                !Number.isNaN(participantMax) && { participant_max: participantMax }),
            };

            if (!transformedFeatures[key]) {
              transformedFeatures[key] = {
                name: key,
                [planKey]: {
                  [priceKey]: priceEntry,
                },
              };
            } else if (!transformedFeatures[key][planKey]) {
              transformedFeatures[key][planKey] = {
                [priceKey]: priceEntry,
              };
            } else {
              transformedFeatures[key][planKey][priceKey] = priceEntry;
            }
          });
      });
      return Object.values(transformedFeatures);
    };

    const allowedPlanNames = ["total suite", "elevated", "platinum plan"];
    const planSortOrder = {
      "total suite": 0,
      elevated: 1,
      "platinum plan": 2,
    };

    const onlySelectedplan = PricingData?.filter((plan) =>
      allowedPlanNames.includes(plan.name.toLowerCase().trim())
    )?.sort(
      (a, b) =>
        (planSortOrder[a.name.toLowerCase().trim()] ?? 99) -
        (planSortOrder[b.name.toLowerCase().trim()] ?? 99)
    );

    const transformedData = transformData(onlySelectedplan);
    function getLowerBound(name) {
      const match = name.match(/(\d+)\s+to\s+\d+\s+Participants/);
      if (match) {
        return parseInt(match[1]);
      }
      return null;
    }

    return transformedData.sort((a, b) => {
      const lowerBoundA = getLowerBound(a.name);
      const lowerBoundB = getLowerBound(b.name);
      return lowerBoundA - lowerBoundB;
    });
  }
);

export const getStripeSaveCardDataLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("stripeSaveCardDataLoader") || false
);

export const getStripeListAllCardsLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("stripeListAllCardLoader") || false
);

export const getStripeListAllCards = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("stripeCards") || []
);

export const getStripeGetDefaultPaymentMethodLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("stripeGetDefaultPaymentMethodLoader") || false
);

export const getStripeSaveCardDataError = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("stripeSaveCardDataError") || ""
);

export const getStripeAttachSubscribeSuccess = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("stripeAttachSubscribeSuccess") === true
);

export const getSpStaffComplianceSettingFetchLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spStaffComplianceSettingFetchLoader") || false
);

export const getSpStaffComplianceSetting = createSelector(
  spAdminStateData,
  (spAdmin) =>
    spAdmin.get("spStaffComplianceSetting") || { document: [], form: [], worker_compliance_email_notification: false }
);

export const getSpStaffComplianceSettingUpdateLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spStaffComplianceSettingUpdateLoader") || false
);

export const getSpStaffComplianceAddDocumentCompleted = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spStaffComplianceAddDocumentCompleted") || null
);

export const getSpStaffComplianceCreateCategoryCompleted = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spStaffComplianceCreateCategoryCompleted") || null
);

export const getSpParticipantComplianceSettingFetchLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spParticipantComplianceSettingFetchLoader") || false
);

export const getSpParticipantComplianceSetting = createSelector(
  spAdminStateData,
  (spAdmin) =>
    spAdmin.get("spParticipantComplianceSetting") || { document: [], form: [] }
);

export const getSpParticipantComplianceSettingUpdateLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spParticipantComplianceSettingUpdateLoader") || false
);

export const getSpParticipantComplianceSettingUpdateError = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spParticipantComplianceSettingUpdateError") || ""
);

export const getSpParticipantComplianceAddDocumentCompleted = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spParticipantComplianceAddDocumentCompleted") || null
);

export const getSpParticipantComplianceUpdateDocumentCompleted = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spParticipantComplianceUpdateDocumentCompleted") || null
);

export const getSpParticipantComplianceCreateCategoryCompleted = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spParticipantComplianceCreateCategoryCompleted") || null
);

export const getSpRosteringSettingLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spRosteringSettingFetchLoader") || false
);

export const getSpRosteringSettingUpdateLoader = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spRosteringSettingUpdateLoader") || false
);

export const getSpRosteringSetting = createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("spRosteringSetting") || null
);

/** Org-level care sector from cache, SP settings, or general (rostering) settings. */
export const getCareSector = createSelector(
  [getSpSetting, getSpRosteringSetting],
  (spSetting, spRosteringSetting) =>
    getCachedCareSector() ||
    spSetting?.care_sector ||
    spRosteringSetting?.care_sector ||
    null
);
export const getXeroSubscriptionData=createSelector(
  spAdminStateData,
  (spAdmin) => spAdmin.get("xeroSubscriptionPusherReceived") || null
)